export async function getUsersIndicator() {
  return new Promise((resolve) => {
    const users = 2700;
    setTimeout(() => {
      resolve(users);
    }, 1000);
  });
}
